import styled from 'styled-components';

import {
  BREAKPOINTS,
  colors,
  FONT_FAMILIES,
} from 'common/styles/style-constants';
import { CheckCircleFilled, Modal } from 'opencare-crown';

export const StyledModal = styled(Modal)`
  && {
    .ant-modal-content {
      background: ${colors.gray};
    }

    .ant-modal-body {
      padding: 0;

      @media (min-width: ${BREAKPOINTS.tabletMin}px) {
        padding: 24px;
      }
    }
  }
`;

export const H1 = styled.h1`
  color: ${colors.blue};
  margin-bottom: 30px;
  font-size: 35px;
  line-height: 44px;
`;

export const Inline = styled.span`
  display: block;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    display: initial;
    font-size: 40px;
  }
`;

export const H2 = styled.h2`
  color: ${colors.blue};
  font-size: 23px;
  margin-bottom: 10px;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    font-size: 27px;
  }
`;

export const Timeline = styled.ol`
  list-style-type: none;
  counter-reset: timeline-counter;
  padding-left: 0;
  max-width: 375px;
  margin: 0 auto 20px;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    display: flex;
    max-width: 100%;
    margin: 0;
  }
`;

export const TimelineItem = styled.li`
  display: flex;
  align-items: stretch;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    text-align: center;
    display: inline-block;
  }

  /* Line between numbers */
  &:not(:last-child) > p:before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    background: ${colors.gray8};
    top: 50%;
    left: 15px;

    @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
      width: 100%;
      height: 2px;
      top: 15px;
      left: 50%;
    }
  }
`;

export const TimelineCopy = styled.p`
  position: relative;
  font-family: ${FONT_FAMILIES.circular};
  font-weight: 900;
  font-size: 15px;
  color: ${colors.charcoal};
  margin-left: 15px;
  padding-left: 45px;
  padding-top: 8%;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    padding: 40px 7%;
    margin-top: 5px;
    margin-left: 0;
  }

  &:after {
    content: counter(timeline-counter);
    counter-increment: timeline-counter;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background: ${colors.gray8};
    color: ${colors.white};
    font-size: 18px;
    line-height: 1.1;
    text-align: center;
    width: 30px;
    height: 30px;
    padding: 5px;
    border-radius: 50%;

    @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export const Img = styled.img`
  height: 100px;
`;

export const Link = styled.a`
  color: ${(props) => props.color || 'inherit'};

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    color: ${(props) => props.color || 'inherit'};
  }
`;

export const UL = styled.ul`
  margin-top: 30px;
  margin-bottom: 40px;
  padding-left: 0;
  font-size: 18px;
  list-style-type: none;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    font-size: 15px;
  }

  > li {
    display: flex;
    align-items: baseline;
    margin-bottom: 10px;
  }
`;

export const Checkmark = styled(CheckCircleFilled)`
  && {
    color: #93bd56;
    font-size: 20px;
    margin-right: 10px;
  }
`;
